// ============================================================================
// CHINESE TRANSLATIONS - CHAPTER 8: 至高者的庇护 (奖励关卡)
// ============================================================================
// 第92关 (1个奖励关卡, 3个问题)

export const chapter8Translations = {
  name: "至高者的庇护",
  description: "住在至高者隐密处的,必住在全能者的荫下",
  
  spiritualWisdom: {
    principle: "你已经到达了山顶,知识已经获得",
    scripture: "住在至高者隐密处的,必住在全能者的荫下 (诗篇91:1)",
    application: "坚定不移的信仰需要生活经验、怜悯和耶稣真正的爱。考验将测试你的心,你所选择的真正道路。"
  },
  
  levels: {
    92: {
      name: "至高者的隐密处",
      challenge: "你在山顶上... 但坚定不移的信仰现在才开始...",
      easy: {
        question: "耶稣对你个人来说是谁?",
        options: [
          "一个简单的先知",
          "我个人的主和救主",
          "一个传说",
          "一个哲学家"
        ],
        hint: "祂是那位为拯救我们而舍命的",
        funFact: "✝️ 耶稣就是神!祂不仅仅是一个历史人物 - 祂活着,并且渴望与我们每个人建立个人关系!"
      },
      medium: {
        question: "为什么像但以理一样禁食能让我们更好地听到神?",
        options: [
          "为了减肥",
          "为了剥夺我们所爱的,并拥有一颗转变的心",
          "为了给别人留下深刻印象",
          "为了变得更强壮"
        ],
        hint: "剥夺你最爱的东西,在平静和智慧中",
        funFact: "🙏 属灵的禁食预备我们的心迎接深刻的转变 - 往往是痛苦的 - 使我们更接近神!"
      },
      hard: {
        question: "面对所有这些获得的知识,心灵真正的回应是什么?",
        options: [
          "我现在完美了",
          "我将我的心献给你,耶稣,我渴望受洗",
          "我比别人知道得更多",
          "我不再需要帮助"
        ],
        hint: "真正的信仰导致完全的顺服和对耶稣的承诺",
        funFact: "🌟✨ 你已经到达了山顶,知识已经获得 ✨\n\n💖 坚定不移的信仰需要生活经验、怜悯和耶稣真正的爱 💖\n\n🔥 生活中的各种考验将测试你的道路,我们选择的真正路径,我们的心 🔥\n\n😔 我们仍然不完美,我们的欲望很多,对金钱或个人舒适的爱常常成为我们自私的优先事项 😔\n\n🙏 向神求智慧、祂的爱、祂的力量,并谦卑地承认你的软弱,因为我们无法向祂隐藏任何事... 任何事 🙏\n\n🥖 像但以理一样禁食:暂时剥夺你最爱的东西,在平静和智慧中 🥖\n\n💫 这将使你更好地听到神,拥有一颗准备好迎接深刻转变的心 💫\n\n🌙 然后,梦和异象会变得更清晰,就像约瑟一样 🌙\n\n⚠️ 要警惕骄傲:不要屈服于'我总是对的'或'我知道得更多' ⚠️\n\n🎁 因为神的启示是非凡的恩典 🎁\n\n💝 拥有信仰就是进入一种关系和心灵的自由之路 💝\n\n🦸‍♂️ 它将使你成为强大的英雄,能够做不可能的事 🦸‍♂️\n\n✝️ 在知识的顶峰,真诚的心说:'我将我的心献给你,耶稣,我渴望受洗' ✝️\n\n🏔️ 你已经到达了山顶,坚持住,坚持不懈! 🏔️\n\n⬇️ 必须下山并携带这宝贵的财富:永生的希望 ⬇️\n\n🏆✨ 太棒了!我们为你骄傲 ✨🏆\n🌟 勇敢的和平使者,勇气 🌟\n🕊️✨ 愿神祝福你 ✨🕊️"
      }
    }
  }
};

export default chapter8Translations;
